<template>
  <collection :collection="collection" :products="products" />
</template>

<script>
import Collection from '~/components/collection/Collection.vue'
import pushDataLayer from '~/mixins/gtm/push-data-layer'

export default {
  components: { Collection },
  mixins: [pushDataLayer],
  async asyncData({
    $axios,
    store,
    params: { slug },
    query: { page },
    route,
    error,
    $sentry,
    $isBrStore,
    ...ctx
  }) {
    try {
      const params = {
        ...store.getters.storeInfo,
      }

      const endpointUrl = `/collections/${slug}`

      if (store.state.skipStoreValidation) {
        params.skip_product_store = true
      }

      const { collection } = await $axios.$get(endpointUrl, {
        params,
      })

      const { products } = collection

      return {
        collection,
        products,
      }
    } catch (err) {
      error({
        statusCode: 404,
        message: 'Collection not found',
      })
    }
  },
  data() {
    return {
      collection: {},
      products: [],
    }
  },
  mounted() {
    this.sendToGtm()
  },
  methods: {
    sendToGtm() {
      this.pushDataLayer({
        event: 'genericEvent',
        eventCategory: 'navigation',
        eventAction: 'viewCollections',
        eventValue: {},
      })
    },
  },
  head() {
    return {
      // eslint-disable-next-line camelcase
      title: this.collection?.meta_title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            // eslint-disable-next-line camelcase
            `${
              // eslint-disable-next-line camelcase
              this.collection?.meta_description
                ? // eslint-disable-next-line camelcase
                  this.collection?.meta_description
                : this.$t('seo.meta_description')
            }`,
        },
      ],
      script: [
        {
          src:
            'https://cdnjs.cloudflare.com/ajax/libs/jquery/3.1.1/jquery.min.js',
        },
      ],
    }
  },
}
</script>
